import { useState } from 'react';
import Navbar from './components/Navbar';
// import Hero from './components/Hero';
import HelpSection from './components/HelpSection';
import ContactForm from './components/ContactForm';
import { useContactForm } from './hooks/useContactForm';
import { scrollToContact } from './utils/scrollUtils';
import './styles/global.css';

function App() {
  const [showGreenStatus, setShowGreenStatus] = useState(false);
  const { formData, formStatus, handleInputChange, handleFormSubmit } = useContactForm();

  const handleGreenStatusClick = () => {
    setShowGreenStatus(!showGreenStatus);
  };

  return (
    <>
      <Navbar scrollToContact={scrollToContact} />
      {/* <Hero /> */}
      <HelpSection 
        showGreenStatus={showGreenStatus} 
        handleGreenStatusClick={handleGreenStatusClick} 
      />
      <ContactForm 
        formData={formData}
        formStatus={formStatus}
        handleInputChange={handleInputChange}
        handleFormSubmit={handleFormSubmit}
      />
    </>
  );
}

export default App;